/**
 * Normalize Ghana mobile input to 233XXXXXXXXX (12 digits) for API storage.
 * Accepts 024XXXXXXX, +233..., 233..., spaces, dashes, etc.
 */
export function cleanGhanaPhone(input) {
  if (input == null || input === "") return null;

  let digits = String(input)
    .trim()
    .replace(/[\u200B-\u200F\u202A-\u202E]/g, "")
    .replace(/\D/g, "");

  if (!digits) return null;

  if (digits.startsWith("00233")) {
    digits = digits.slice(2);
  }

  if (digits.startsWith("0") && digits.length === 10) {
    digits = `233${digits.slice(1)}`;
  } else if (digits.length === 9) {
    digits = `233${digits}`;
  }

  if (!/^233[2-5]\d{8}$/.test(digits)) {
    return null;
  }

  return digits;
}

/** Local display format: 0XXXXXXXXX */
export function formatGhanaPhoneLocal(input) {
  const cleaned = cleanGhanaPhone(input);
  if (!cleaned) return String(input ?? "").trim();
  return `0${cleaned.slice(3)}`;
}

export function isValidGhanaPhone(input) {
  return cleanGhanaPhone(input) != null;
}

/** Strip formatting only — use before validation when you need the raw digits path. */
export function stripPhoneFormatting(input) {
  if (input == null) return "";
  return String(input).trim().replace(/\s+/g, "");
}
